<template>
  <v-app>
    <v-app-bar
      app
      class="bg-color"
      height="86"
    >
      <div class="d-flex align-center">
        <v-img
          class="shrink mr-2 max-logo"
          contain
          src="@/assets/isotipo.png"
          transition="scale-transition"

        />
      </div>

      <v-spacer></v-spacer>

      <span class="producto">un producto de <span class="secu">Security 24®</span></span>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import moment from 'moment-timezone'
moment.tz.setDefault('America/Argentina/Buenos_Aires')
export default {
  name: 'App',

  data: () => ({
    //
  })
};
</script>
